"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPE = exports.ICON = exports.DATEWRAPPER_HEIGHT = exports.BORDER_COLOR = void 0;
var ICON = {
  FONT: 'DateRangeIcon'
};
exports.ICON = ICON;
var TYPE = {
  DEPART: 'depart',
  RETURN: 'return'
};
exports.TYPE = TYPE;
var DATEWRAPPER_HEIGHT = '56px';
exports.DATEWRAPPER_HEIGHT = DATEWRAPPER_HEIGHT;
var BORDER_COLOR = {
  SELECTION: 'secondary',
  DEFAULT: 'greyMedium'
};
exports.BORDER_COLOR = BORDER_COLOR;